import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Col, Row, Tabs } from 'antd'
import LoyaltyOverview from './LoyaltyOverview'
import LoyaltyCards from './LoyaltyCards'
import LoyaltyBonusContainer from './LoyaltyBonusContainer'
import LoyaltySettings from './LoyaltySettings'
import { MultipliersList } from './Multipliers/MultipliersList'

const { TabPane } = Tabs

const Loyalty = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const getActiveKey = () => {
    if (location.pathname === '/loyalty') return 'overview'
    if (location.pathname.includes('/loyalty/cards')) return 'cards'
    if (location.pathname.includes('/loyalty/bonuses-and-multipliers'))
      return 'bonuses-and-multipliers'
    if (location.pathname.includes('/loyalty/settings')) return 'settings'
    return 'overview'
  }

  const handleTabChange = (key: string) => {
    navigate(`/loyalty/${key}`)
  }

  useEffect(() => {
    if (location.pathname === '/loyalty') {
      navigate('/loyalty/overview', { replace: true })
    }
  }, [location.pathname, navigate])

  return (
    <>
      <Row>
        <Col span={24}>
          <Tabs
            type='card'
            activeKey={getActiveKey()}
            onChange={handleTabChange}
            data-testid='loyaltyIndex'
            destroyInactiveTabPane
          >
            <TabPane
              tab={<a data-testid='loyalty-overview-tab-pane'>OVERVIEW</a>}
              key='overview'
            >
              <LoyaltyOverview />
            </TabPane>
            <TabPane
              tab={<a data-testid='loyalty-cards-tab-pane'>YOUR CARDS</a>}
              key='cards'
            >
              <LoyaltyCards />
            </TabPane>
            <TabPane
              tab={
                <a data-testid='loyalty-bonuses-tab-pane'>
                  BONUSES AND MULTIPLIERS
                </a>
              }
              key='bonuses-and-multipliers'
            >
              <MultipliersList />
              <LoyaltyBonusContainer
                basePath='/loyalty/bonuses-and-multipliers'
                heading='Loyalty Bonuses'
              />
            </TabPane>
            <TabPane
              tab={<a data-testid='loyalty-bonuses-tab-pane'>SETTINGS</a>}
              key='settings'
            >
              <LoyaltySettings />
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </>
  )
}

export default Loyalty
